var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courses1"},[_c('div',{staticClass:"courses1_cont",attrs:{"id":"courses1_cont"}},[_c('div',[_c('p',{staticClass:"cn"},[_vm._v(_vm._s(_vm.msg.cname))]),_c('p',{staticClass:"en"},[_vm._v(_vm._s(_vm.msg.ename))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }